import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectorRef
} from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { STComponent } from '@delon/abc/st';
import { Subject, takeUntil } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { DocListBaseService } from '../../services/_base/doc-list-base.service';
@Component({
  selector: 'app-filter-list',
  templateUrl: './filter-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  animations: [
    trigger('toggleFilters', [
      state(
        'hidden',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: 0
        })
      ),
      state(
        'visible',
        style({
          height: '*',
          overflow: 'hidden',
          opacity: 1
        })
      ),
      transition('hidden <=> visible', [animate('300ms ease-in-out')])
    ])
  ]
})
export class FilterListComponent implements OnInit, OnDestroy {
  getFormControl(key: string): FormControl<any> {
    return this.form.get(key) as FormControl<any>;
  }
  public form: FormGroup = new FormGroup({});
  private _st: STComponent | undefined;
  get st(): STComponent | undefined {
    return this._st;
  }
  @Input() set st(component: STComponent | undefined) {
    this._st = component;
    this.srv.st = component;
  }
  @Input() firstLineFieldNumber: number = 3;
  @Output() readonly filterChange: EventEmitter<any> = new EventEmitter<any>();
  showMoreFilters = false;
  destroy$ = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    public srv: DocListBaseService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.initializeForm();
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.srv.filterValues = this.form.value;
      this.filterChange!.emit(this.form.value);
    });
    this.form.valueChanges
      .pipe(takeUntil(this.destroy$), debounceTime(300))
      .subscribe(() => {
        this.onSubmit();
      });
  }

  initializeForm(): void {
    const formControls = this.srv.filterColumns.reduce(
      (controls: { [key: string]: FormControl }, column) => {
        controls[column.key] = new FormControl('');
        return controls;
      },
      {}
    );

    this.form = this.fb.group(formControls);
  }

  toggleMoreFilters(): void {
    this.showMoreFilters = !this.showMoreFilters;
    this.cdr.detectChanges();
  }

  onSubmit(): void {
    if (this.st) this.st.reset();
  }
}
